export enum AtomKey {
  GOOGLE_MAPS = 'GOOGLE_MAPS',
  MAP = 'MAP'
}
